module.exports = __webpack_public_path__ + "img/Astronaut-Bull.cbc7afc1.png";